var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 183,
    viewBox: "0 0 183 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1241_4146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.289 140.166H0.806824V140.257H182.289V140.166Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.105 146.029H152.083V146.121H164.105V146.029Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.028 147.018H117.873V147.109H121.028V147.018Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.719 142.647H144.753V142.738H151.719V142.647Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.525 143.259H19.8475V143.35H35.525V143.259Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0557 143.259H38.757V143.35H41.0557V143.259Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5272 144.797H48.5262V144.888H82.5272V144.797Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8345 123.921H16.7464C15.6042 123.921 14.6746 122.988 14.6746 121.841V22.9681C14.6746 21.8218 15.6042 20.8889 16.7464 20.8889H86.8345C87.9764 20.8889 88.9059 21.8218 88.9059 22.9681V121.841C88.9059 122.988 87.9764 123.921 86.8345 123.921ZM16.7464 20.9803C15.6539 20.9803 14.7654 21.8721 14.7654 22.9685V121.842C14.7654 122.938 15.6539 123.83 16.7464 123.83H86.8345C87.9266 123.83 88.8152 122.938 88.8152 121.842V22.9681C88.8152 21.8721 87.9266 20.98 86.8345 20.98L16.7464 20.9803Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.342 123.921H95.2546C94.1124 123.921 93.1832 122.988 93.1832 121.841V22.9681C93.1832 21.8218 94.1127 20.8889 95.2546 20.8889H165.342C166.485 20.8889 167.414 21.8218 167.414 22.9681V121.841C167.414 122.988 166.485 123.921 165.342 123.921ZM95.2546 20.9803C94.1624 20.9803 93.2739 21.8721 93.2739 22.9685V121.842C93.2739 122.938 94.1624 123.83 95.2546 123.83H165.342C166.435 123.83 167.323 122.938 167.323 121.842V22.9681C167.323 21.8721 166.435 20.98 165.342 20.98L95.2546 20.9803Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.478 43.555H74.5389V128.625H162.478V43.555Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.478 45.0999H75.9502V127.142H162.478V45.0999Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5886 107.272V82.5955H79.1432V79.336L84.8914 76.6379V73.3016H85.8493V82.5955H86.8072V107.272H88.0844V94.4531H90.9584V87.7229H91.9166V107.272H94.1517V99.901H95.7484V97.9781H99.2612V91.2483H101.177V86.7616H103.412V80.0318H104.37V86.7616H106.606V91.2483H108.522V97.9781H112.034V99.901H113.631V107.272H115.547V97.9781H119.059V77.4677H120.018V75.2246H127.682V77.4677H129.278V92.2096H135.665V93.812H137.9V94.7736H135.665V100.542H142.371V81.3136H143.648V77.4677H146.841V62.7259H147.799V77.4677H150.035V81.3136H162.478V127.142H75.9502V107.272H76.5886Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.829 82.3183H154.924V83.2264H155.829V82.3183Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.829 83.8406H154.924V84.7487H155.829V83.8406Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.829 89.9296H154.924V90.8377H155.829V89.9296Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.829 91.4519H154.924V92.36H155.829V91.4519Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.829 92.9742H154.924V93.8823H155.829V92.9742Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.829 97.541H154.924V98.4491H155.829V97.541Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.829 99.0632H154.924V99.9714H155.829V99.0632Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.392 88.4074H153.487V89.3155H154.392V88.4074Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.392 89.9296H153.487V90.8377H154.392V89.9296Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.392 91.4519H153.487V92.36H154.392V91.4519Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.392 92.9742H153.487V93.8823H154.392V92.9742Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.392 94.4965H153.487V95.4046H154.392V94.4965Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.392 97.541H153.487V98.4491H154.392V97.541Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.392 99.0632H153.487V99.9714H154.392V99.0632Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.955 82.3183H152.05V83.2264H152.955V82.3183Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.955 83.8406H152.05V84.7487H152.955V83.8406Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.955 85.3629H152.05V86.271H152.955V85.3629Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.955 86.8851H152.05V87.7932H152.955V86.8851Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.955 88.4074H152.05V89.3155H152.955V88.4074Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.955 89.9296H152.05V90.8377H152.955V89.9296Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.955 91.4519H152.05V92.36H152.955V91.4519Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.955 92.9742H152.05V93.8823H152.955V92.9742Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.955 94.4965H152.05V95.4046H152.955V94.4965Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.955 96.0187H152.05V96.9268H152.955V96.0187Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.955 99.0632H152.05V99.9714H152.955V99.0632Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.518 82.3183H150.613V83.2264H151.518V82.3183Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.518 83.8406H150.613V84.7487H151.518V83.8406Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.518 85.3629H150.613V86.271H151.518V85.3629Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.518 86.8851H150.613V87.7932H151.518V86.8851Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.518 88.4074H150.613V89.3155H151.518V88.4074Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.518 89.9296H150.613V90.8377H151.518V89.9296Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.518 91.4519H150.613V92.36H151.518V91.4519Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.518 105.152H150.613V106.06H151.518V105.152Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.081 82.3183H149.177V83.2264H150.081V82.3183Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.081 83.8406H149.177V84.7487H150.081V83.8406Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.081 85.3629H149.177V86.271H150.081V85.3629Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.081 86.8851H149.177V87.7932H150.081V86.8851Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.081 88.4074H149.177V89.3155H150.081V88.4074Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.081 89.9296H149.177V90.8377H150.081V89.9296Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.081 91.4519H149.177V92.36H150.081V91.4519Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.081 92.9742H149.177V93.8823H150.081V92.9742Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.081 102.108H149.177V103.016H150.081V102.108Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.081 103.63H149.177V104.538H150.081V103.63Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.081 105.152H149.177V106.06H150.081V105.152Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.081 106.675H149.177V107.583H150.081V106.675Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.081 112.764H149.177V113.672H150.081V112.764Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.644 82.3183H147.739V83.2264H148.644V82.3183Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.644 83.8406H147.739V84.7487H148.644V83.8406Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.644 85.3629H147.739V86.271H148.644V85.3629Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.644 86.8851H147.739V87.7932H148.644V86.8851Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.644 88.4074H147.739V89.3155H148.644V88.4074Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.644 89.9296H147.739V90.8377H148.644V89.9296Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.644 91.4519H147.739V92.36H148.644V91.4519Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.644 92.9742H147.739V93.8823H148.644V92.9742Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.644 94.4965H147.739V95.4046H148.644V94.4965Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.644 96.0187H147.739V96.9268H148.644V96.0187Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.644 100.586H147.739V101.494H148.644V100.586Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.644 102.108H147.739V103.016H148.644V102.108Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.644 103.63H147.739V104.538H148.644V103.63Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.644 105.152H147.739V106.06H148.644V105.152Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.644 106.675H147.739V107.583H148.644V106.675Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.644 112.764H147.739V113.672H148.644V112.764Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.207 82.3183H146.302V83.2264H147.207V82.3183Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.207 83.8406H146.302V84.7487H147.207V83.8406Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.207 85.3629H146.302V86.271H147.207V85.3629Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.207 86.8851H146.302V87.7932H147.207V86.8851Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.207 88.4074H146.302V89.3155H147.207V88.4074Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.207 89.9296H146.302V90.8377H147.207V89.9296Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.207 91.4519H146.302V92.36H147.207V91.4519Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.207 92.9742H146.302V93.8823H147.207V92.9742Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.207 94.4965H146.302V95.4046H147.207V94.4965Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.207 96.0187H146.302V96.9268H147.207V96.0187Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.207 97.541H146.302V98.4491H147.207V97.541Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.207 99.0632H146.302V99.9714H147.207V99.0632Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.207 100.586H146.302V101.494H147.207V100.586Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.207 102.108H146.302V103.016H147.207V102.108Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.207 103.63H146.302V104.538H147.207V103.63Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.207 105.152H146.302V106.06H147.207V105.152Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.207 106.675H146.302V107.583H147.207V106.675Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.207 108.197H146.302V109.105H147.207V108.197Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.77 82.3183H144.865V83.2264H145.77V82.3183Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.77 83.8406H144.865V84.7487H145.77V83.8406Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.77 85.3629H144.865V86.271H145.77V85.3629Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.77 86.8851H144.865V87.7932H145.77V86.8851Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.77 88.4074H144.865V89.3155H145.77V88.4074Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.77 89.9296H144.865V90.8377H145.77V89.9296Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.77 91.4519H144.865V92.36H145.77V91.4519Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.77 92.9742H144.865V93.8823H145.77V92.9742Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.77 94.4965H144.865V95.4046H145.77V94.4965Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.77 96.0187H144.865V96.9268H145.77V96.0187Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.77 100.586H144.865V101.494H145.77V100.586Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.77 102.108H144.865V103.016H145.77V102.108Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.77 103.63H144.865V104.538H145.77V103.63Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.77 105.152H144.865V106.06H145.77V105.152Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.333 82.3183H143.428V83.2264H144.333V82.3183Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.333 83.8406H143.428V84.7487H144.333V83.8406Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.333 85.3629H143.428V86.271H144.333V85.3629Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.333 86.8851H143.428V87.7932H144.333V86.8851Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.333 88.4074H143.428V89.3155H144.333V88.4074Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.333 89.9296H143.428V90.8377H144.333V89.9296Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.333 91.4519H143.428V92.36H144.333V91.4519Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.333 92.9742H143.428V93.8823H144.333V92.9742Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.333 94.4965H143.428V95.4046H144.333V94.4965Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.333 96.0187H143.428V96.9268H144.333V96.0187Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.333 100.586H143.428V101.494H144.333V100.586Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.333 102.108H143.428V103.016H144.333V102.108Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.333 103.63H143.428V104.538H144.333V103.63Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.154 78.3657H127.249V79.2738H128.154V78.3657Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.154 79.8879H127.249V80.7961H128.154V79.8879Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.154 81.4102H127.249V82.3183H128.154V81.4102Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.154 82.9324H127.249V83.8406H128.154V82.9324Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.154 84.4547H127.249V85.3628H128.154V84.4547Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.154 85.977H127.249V86.8851H128.154V85.977Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.154 87.4993H127.249V88.4074H128.154V87.4993Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.154 89.0215H127.249V89.9297H128.154V89.0215Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.154 93.5883H127.249V94.4964H128.154V93.5883Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.154 95.1106H127.249V96.0187H128.154V95.1106Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.717 78.3657H125.812V79.2738H126.717V78.3657Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.717 79.8879H125.812V80.7961H126.717V79.8879Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.717 81.4102H125.812V82.3183H126.717V81.4102Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.717 82.9324H125.812V83.8406H126.717V82.9324Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.717 84.4547H125.812V85.3628H126.717V84.4547Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.717 85.977H125.812V86.8851H126.717V85.977Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.717 87.4993H125.812V88.4074H126.717V87.4993Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.717 89.0215H125.812V89.9297H126.717V89.0215Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.717 95.1106H125.812V96.0187H126.717V95.1106Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.28 78.3657H124.375V79.2738H125.28V78.3657Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.28 79.8879H124.375V80.7961H125.28V79.8879Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.28 81.4102H124.375V82.3183H125.28V81.4102Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.28 82.9324H124.375V83.8406H125.28V82.9324Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.28 84.4547H124.375V85.3628H125.28V84.4547Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.28 85.977H124.375V86.8851H125.28V85.977Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.28 87.4993H124.375V88.4074H125.28V87.4993Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.28 89.0215H124.375V89.9297H125.28V89.0215Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.843 78.3657H122.938V79.2738H123.843V78.3657Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.843 79.8879H122.938V80.7961H123.843V79.8879Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.843 81.4102H122.938V82.3183H123.843V81.4102Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.843 82.9324H122.938V83.8406H123.843V82.9324Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.843 84.4547H122.938V85.3628H123.843V84.4547Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.843 85.977H122.938V86.8851H123.843V85.977Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.843 89.0215H122.938V89.9297H123.843V89.0215Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.843 90.5438H122.938V91.4519H123.843V90.5438Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.843 95.1106H122.938V96.0187H123.843V95.1106Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.843 96.6329H122.938V97.541H123.843V96.6329Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.843 98.1552H122.938V99.0633H123.843V98.1552Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.843 99.6774H122.938V100.585H123.843V99.6774Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.843 101.2H122.938V102.108H123.843V101.2Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.843 102.722H122.938V103.63H123.843V102.722Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.843 104.244H122.938V105.152H123.843V104.244Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.406 78.3657H121.501V79.2738H122.406V78.3657Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.406 79.8879H121.501V80.7961H122.406V79.8879Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.406 81.4102H121.501V82.3183H122.406V81.4102Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.406 82.9324H121.501V83.8406H122.406V82.9324Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.406 84.4547H121.501V85.3628H122.406V84.4547Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.406 85.977H121.501V86.8851H122.406V85.977Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.406 90.5438H121.501V91.4519H122.406V90.5438Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.406 92.066H121.501V92.9742H122.406V92.066Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.406 93.5883H121.501V94.4964H122.406V93.5883Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.406 95.1106H121.501V96.0187H122.406V95.1106Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.406 96.6329H121.501V97.541H122.406V96.6329Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.406 98.1552H121.501V99.0633H122.406V98.1552Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.406 99.6774H121.501V100.585H122.406V99.6774Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.406 101.2H121.501V102.108H122.406V101.2Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.406 102.722H121.501V103.63H122.406V102.722Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.406 104.244H121.501V105.152H122.406V104.244Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.406 105.766H121.501V106.675H122.406V105.766Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.406 108.811H121.501V109.719H122.406V108.811Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.969 78.3657H120.064V79.2738H120.969V78.3657Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.969 79.8879H120.064V80.7961H120.969V79.8879Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.969 81.4102H120.064V82.3183H120.969V81.4102Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.969 82.9324H120.064V83.8406H120.969V82.9324Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.969 84.4547H120.064V85.3628H120.969V84.4547Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.969 85.977H120.064V86.8851H120.969V85.977Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.969 90.5438H120.064V91.4519H120.969V90.5438Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.969 92.066H120.064V92.9742H120.969V92.066Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.969 93.5883H120.064V94.4964H120.969V93.5883Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.969 95.1106H120.064V96.0187H120.969V95.1106Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.969 99.6774H120.064V100.585H120.969V99.6774Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.969 101.2H120.064V102.108H120.969V101.2Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.969 102.722H120.064V103.63H120.969V102.722Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.969 104.244H120.064V105.152H120.969V104.244Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.969 105.766H120.064V106.675H120.969V105.766Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.969 108.811H120.064V109.719H120.969V108.811Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.969 110.333H120.064V111.241H120.969V110.333Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.93 92.5203H107.025V93.4284H107.93V92.5203Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.93 94.0425H107.025V94.9507H107.93V94.0425Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.93 95.5648H107.025V96.4729H107.93V95.5648Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.93 97.0867H107.025V97.9948H107.93V97.0867Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.93 98.6094H107.025V99.5175H107.93V98.6094Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.93 100.131H107.025V101.039H107.93V100.131Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.93 101.654H107.025V102.562H107.93V101.654Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.93 106.22H107.025V107.128H107.93V106.22Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.93 107.743H107.025V108.651H107.93V107.743Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.93 109.265H107.025V110.173H107.93V109.265Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.493 92.5203H105.588V93.4284H106.493V92.5203Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.493 94.0425H105.588V94.9507H106.493V94.0425Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.493 95.5648H105.588V96.4729H106.493V95.5648Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.493 97.0867H105.588V97.9948H106.493V97.0867Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.493 98.6094H105.588V99.5175H106.493V98.6094Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.493 100.131H105.588V101.039H106.493V100.131Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.493 101.654H105.588V102.562H106.493V101.654Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.056 92.5203H104.151V93.4284H105.056V92.5203Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.056 94.0425H104.151V94.9507H105.056V94.0425Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.056 95.5648H104.151V96.4729H105.056V95.5648Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.056 97.0867H104.151V97.9948H105.056V97.0867Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.056 98.6094H104.151V99.5175H105.056V98.6094Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.056 100.131H104.151V101.039H105.056V100.131Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.056 101.654H104.151V102.562H105.056V101.654Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.619 92.5203H102.714V93.4284H103.619V92.5203Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.619 94.0425H102.714V94.9507H103.619V94.0425Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.619 95.5648H102.714V96.4729H103.619V95.5648Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.619 97.0867H102.714V97.9948H103.619V97.0867Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.619 98.6094H102.714V99.5175H103.619V98.6094Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.619 100.131H102.714V101.039H103.619V100.131Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.619 101.654H102.714V102.562H103.619V101.654Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.619 103.176H102.714V104.084H103.619V103.176Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.619 104.698H102.714V105.606H103.619V104.698Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.619 106.22H102.714V107.128H103.619V106.22Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.619 107.743H102.714V108.651H103.619V107.743Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.182 92.5203H101.277V93.4284H102.182V92.5203Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.182 94.0425H101.277V94.9507H102.182V94.0425Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.182 95.5648H101.277V96.4729H102.182V95.5648Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.182 97.0867H101.277V97.9948H102.182V97.0867Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.182 98.6094H101.277V99.5175H102.182V98.6094Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.182 100.131H101.277V101.039H102.182V100.131Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.182 101.654H101.277V102.562H102.182V101.654Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.182 103.176H101.277V104.084H102.182V103.176Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.182 104.698H101.277V105.606H102.182V104.698Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.182 106.22H101.277V107.128H102.182V106.22Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.182 107.743H101.277V108.651H102.182V107.743Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.182 109.265H101.277V110.173H102.182V109.265Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.182 113.832H101.277V114.74H102.182V113.832Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.182 115.354H101.277V116.262H102.182V115.354Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.745 92.5203H99.8397V93.4284H100.745V92.5203Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.745 94.0425H99.8397V94.9507H100.745V94.0425Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.745 95.5648H99.8397V96.4729H100.745V95.5648Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.745 100.131H99.8397V101.039H100.745V100.131Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.745 101.654H99.8397V102.562H100.745V101.654Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.745 103.176H99.8397V104.084H100.745V103.176Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.745 104.698H99.8397V105.606H100.745V104.698Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.745 106.22H99.8397V107.128H100.745V106.22Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.745 107.743H99.8397V108.651H100.745V107.743Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.745 109.265H99.8397V110.173H100.745V109.265Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.745 113.832H99.8397V114.74H100.745V113.832Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.745 115.354H99.8397V116.262H100.745V115.354Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.745 116.876H99.8397V117.784H100.745V116.876Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6826 83.3867H84.7777V84.2948H85.6826V83.3867Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6826 84.909H84.7777V85.8171H85.6826V84.909Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6826 86.4312H84.7777V87.3393H85.6826V86.4312Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6826 87.9535H84.7777V88.8616H85.6826V87.9535Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6826 89.4758H84.7777V90.3839H85.6826V89.4758Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6826 90.998H84.7777V91.9062H85.6826V90.998Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6826 92.5203H84.7777V93.4284H85.6826V92.5203Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6826 94.0425H84.7777V94.9507H85.6826V94.0425Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6826 95.5648H84.7777V96.4729H85.6826V95.5648Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6826 97.0867H84.7777V97.9948H85.6826V97.0867Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6826 98.6094H84.7777V99.5175H85.6826V98.6094Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6826 100.131H84.7777V101.039H85.6826V100.131Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6826 101.654H84.7777V102.562H85.6826V101.654Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6826 103.176H84.7777V104.084H85.6826V103.176Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6826 104.698H84.7777V105.606H85.6826V104.698Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6826 106.22H84.7777V107.128H85.6826V106.22Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6826 107.743H84.7777V108.651H85.6826V107.743Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6826 109.265H84.7777V110.173H85.6826V109.265Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6826 110.787H84.7777V111.695H85.6826V110.787Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6826 112.309H84.7777V113.217H85.6826V112.309Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6826 113.832H84.7777V114.74H85.6826V113.832Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6826 115.354H84.7777V116.262H85.6826V115.354Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6826 116.876H84.7777V117.784H85.6826V116.876Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2457 83.3867H83.3409V84.2948H84.2457V83.3867Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2457 84.909H83.3409V85.8171H84.2457V84.909Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2457 86.4312H83.3409V87.3393H84.2457V86.4312Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2457 87.9535H83.3409V88.8616H84.2457V87.9535Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2457 89.4758H83.3409V90.3839H84.2457V89.4758Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2457 90.998H83.3409V91.9062H84.2457V90.998Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2457 92.5203H83.3409V93.4284H84.2457V92.5203Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2457 94.0425H83.3409V94.9507H84.2457V94.0425Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2457 95.5648H83.3409V96.4729H84.2457V95.5648Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2457 97.0867H83.3409V97.9948H84.2457V97.0867Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2457 98.6094H83.3409V99.5175H84.2457V98.6094Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2457 100.131H83.3409V101.039H84.2457V100.131Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2457 101.654H83.3409V102.562H84.2457V101.654Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2457 103.176H83.3409V104.084H84.2457V103.176Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2457 104.698H83.3409V105.606H84.2457V104.698Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2457 106.22H83.3409V107.128H84.2457V106.22Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2457 107.743H83.3409V108.651H84.2457V107.743Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2457 109.265H83.3409V110.173H84.2457V109.265Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2457 110.787H83.3409V111.695H84.2457V110.787Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8088 83.3867H81.904V84.2948H82.8088V83.3867Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8088 84.909H81.904V85.8171H82.8088V84.909Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8088 86.4312H81.904V87.3393H82.8088V86.4312Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8088 87.9535H81.904V88.8616H82.8088V87.9535Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8088 89.4758H81.904V90.3839H82.8088V89.4758Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8088 90.998H81.904V91.9062H82.8088V90.998Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8088 92.5203H81.904V93.4284H82.8088V92.5203Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8088 94.0425H81.904V94.9507H82.8088V94.0425Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8088 95.5648H81.904V96.4729H82.8088V95.5648Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8088 97.0867H81.904V97.9948H82.8088V97.0867Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8088 98.6094H81.904V99.5175H82.8088V98.6094Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8088 100.131H81.904V101.039H82.8088V100.131Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8088 101.654H81.904V102.562H82.8088V101.654Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8088 103.176H81.904V104.084H82.8088V103.176Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8088 104.698H81.904V105.606H82.8088V104.698Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8088 106.22H81.904V107.128H82.8088V106.22Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8088 107.743H81.904V108.651H82.8088V107.743Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8088 109.265H81.904V110.173H82.8088V109.265Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8088 110.787H81.904V111.695H82.8088V110.787Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3719 83.3867H80.4671V84.2948H81.3719V83.3867Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3719 84.909H80.4671V85.8171H81.3719V84.909Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3719 86.4312H80.4671V87.3393H81.3719V86.4312Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3719 87.9535H80.4671V88.8616H81.3719V87.9535Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3719 89.4758H80.4671V90.3839H81.3719V89.4758Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3719 90.998H80.4671V91.9062H81.3719V90.998Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3719 92.5203H80.4671V93.4284H81.3719V92.5203Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3719 94.0425H80.4671V94.9507H81.3719V94.0425Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3719 95.5648H80.4671V96.4729H81.3719V95.5648Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3719 97.0867H80.4671V97.9948H81.3719V97.0867Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3719 98.6094H80.4671V99.5175H81.3719V98.6094Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3719 100.131H80.4671V101.039H81.3719V100.131Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3719 101.654H80.4671V102.562H81.3719V101.654Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3719 103.176H80.4671V104.084H81.3719V103.176Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3719 104.698H80.4671V105.606H81.3719V104.698Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9348 83.3867H79.0299V84.2948H79.9348V83.3867Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9348 84.909H79.0299V85.8171H79.9348V84.909Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9348 86.4312H79.0299V87.3393H79.9348V86.4312Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9348 87.9535H79.0299V88.8616H79.9348V87.9535Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9348 89.4758H79.0299V90.3839H79.9348V89.4758Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9348 90.998H79.0299V91.9062H79.9348V90.998Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9348 92.5203H79.0299V93.4284H79.9348V92.5203Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9348 94.0425H79.0299V94.9507H79.9348V94.0425Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9348 95.5648H79.0299V96.4729H79.9348V95.5648Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9348 97.0867H79.0299V97.9948H79.9348V97.0867Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9348 98.6094H79.0299V99.5175H79.9348V98.6094Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9348 100.131H79.0299V101.039H79.9348V100.131Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9348 101.654H79.0299V102.562H79.9348V101.654Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4979 83.3867H77.593V84.2948H78.4979V83.3867Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4979 84.909H77.593V85.8171H78.4979V84.909Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4979 86.4312H77.593V87.3393H78.4979V86.4312Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4979 87.9535H77.593V88.8616H78.4979V87.9535Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4979 89.4758H77.593V90.3839H78.4979V89.4758Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4979 90.998H77.593V91.9062H78.4979V90.998Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4979 92.5203H77.593V93.4284H78.4979V92.5203Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4979 94.0425H77.593V94.9507H78.4979V94.0425Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4979 95.5648H77.593V96.4729H78.4979V95.5648Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4979 97.0867H77.593V97.9948H78.4979V97.0867Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4979 98.6094H77.593V99.5175H78.4979V98.6094Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4979 100.131H77.593V101.039H78.4979V100.131Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.375 82.9324H161.47V83.8406H162.375V82.9324Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.375 84.4547H161.47V85.3628H162.375V84.4547Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.375 85.977H161.47V86.8851H162.375V85.977Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.375 87.4993H161.47V88.4074H162.375V87.4993Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.375 89.0215H161.47V89.9297H162.375V89.0215Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.375 90.5438H161.47V91.4519H162.375V90.5438Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.375 92.066H161.47V92.9742H162.375V92.066Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.375 93.5883H161.47V94.4964H162.375V93.5883Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.375 95.1106H161.47V96.0187H162.375V95.1106Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.375 96.6329H161.47V97.541H162.375V96.6329Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.375 98.1552H161.47V99.0633H162.375V98.1552Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.375 99.6774H161.47V100.585H162.375V99.6774Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.375 101.2H161.47V102.108H162.375V101.2Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.375 102.722H161.47V103.63H162.375V102.722Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.375 104.244H161.47V105.152H162.375V104.244Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.375 105.766H161.47V106.675H162.375V105.766Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.375 107.289H161.47V108.197H162.375V107.289Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.375 110.333H161.47V111.241H162.375V110.333Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.375 111.856H161.47V112.764H162.375V111.856Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.375 113.378H161.47V114.286H162.375V113.378Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.375 114.9H161.47V115.808H162.375V114.9Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.375 116.422H161.47V117.33H162.375V116.422Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.938 82.9324H160.034V83.8406H160.938V82.9324Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.938 84.4547H160.034V85.3628H160.938V84.4547Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.938 85.977H160.034V86.8851H160.938V85.977Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.938 87.4993H160.034V88.4074H160.938V87.4993Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.938 89.0215H160.034V89.9297H160.938V89.0215Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.938 90.5438H160.034V91.4519H160.938V90.5438Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.938 92.066H160.034V92.9742H160.938V92.066Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.938 93.5883H160.034V94.4964H160.938V93.5883Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.938 95.1106H160.034V96.0187H160.938V95.1106Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.938 96.6329H160.034V97.541H160.938V96.6329Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.938 98.1552H160.034V99.0633H160.938V98.1552Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.938 99.6774H160.034V100.585H160.938V99.6774Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.938 101.2H160.034V102.108H160.938V101.2Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.938 102.722H160.034V103.63H160.938V102.722Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.938 104.244H160.034V105.152H160.938V104.244Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.938 105.766H160.034V106.675H160.938V105.766Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.938 114.9H160.034V115.808H160.938V114.9Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.938 116.422H160.034V117.33H160.938V116.422Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.501 82.9324H158.596V83.8406H159.501V82.9324Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.501 84.4547H158.596V85.3628H159.501V84.4547Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.501 85.977H158.596V86.8851H159.501V85.977Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.501 87.4993H158.596V88.4074H159.501V87.4993Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.501 89.0215H158.596V89.9297H159.501V89.0215Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.501 90.5438H158.596V91.4519H159.501V90.5438Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.501 92.066H158.596V92.9742H159.501V92.066Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.501 93.5883H158.596V94.4964H159.501V93.5883Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.501 95.1106H158.596V96.0187H159.501V95.1106Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.501 96.6329H158.596V97.541H159.501V96.6329Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.501 98.1552H158.596V99.0633H159.501V98.1552Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.501 99.6774H158.596V100.585H159.501V99.6774Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.501 101.2H158.596V102.108H159.501V101.2Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.501 102.722H158.596V103.63H159.501V102.722Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.501 104.244H158.596V105.152H159.501V104.244Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.501 105.766H158.596V106.675H159.501V105.766Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.501 108.811H158.596V109.719H159.501V108.811Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.501 110.333H158.596V111.241H159.501V110.333Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.501 111.856H158.596V112.764H159.501V111.856Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.501 113.378H158.596V114.286H159.501V113.378Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.501 116.422H158.596V117.33H159.501V116.422Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.434 93.5883H133.529V94.4964H134.434V93.5883Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.434 95.1106H133.529V96.0187H134.434V95.1106Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.434 96.6329H133.529V97.541H134.434V96.6329Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.434 98.1552H133.529V99.0633H134.434V98.1552Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.434 99.6774H133.529V100.585H134.434V99.6774Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.434 101.2H133.529V102.108H134.434V101.2Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.434 102.722H133.529V103.63H134.434V102.722Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.434 104.244H133.529V105.152H134.434V104.244Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.434 105.766H133.529V106.675H134.434V105.766Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.434 107.289H133.529V108.197H134.434V107.289Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.434 108.811H133.529V109.719H134.434V108.811Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.434 110.333H133.529V111.241H134.434V110.333Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.434 111.856H133.529V112.764H134.434V111.856Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.434 114.9H133.529V115.808H134.434V114.9Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.434 116.422H133.529V117.33H134.434V116.422Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.434 117.945H133.529V118.853H134.434V117.945Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.434 119.467H133.529V120.375H134.434V119.467Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.434 122.511H133.529V123.42H134.434V122.511Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.434 124.034H133.529V124.942H134.434V124.034Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.434 125.556H133.529V126.464H134.434V125.556Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.997 93.5883H132.092V94.4964H132.997V93.5883Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.997 95.1106H132.092V96.0187H132.997V95.1106Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.997 96.6329H132.092V97.541H132.997V96.6329Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.997 98.1552H132.092V99.0633H132.997V98.1552Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.997 99.6774H132.092V100.585H132.997V99.6774Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.997 101.2H132.092V102.108H132.997V101.2Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.997 102.722H132.092V103.63H132.997V102.722Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.997 104.244H132.092V105.152H132.997V104.244Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.997 105.766H132.092V106.675H132.997V105.766Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.997 107.289H132.092V108.197H132.997V107.289Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.997 108.811H132.092V109.719H132.997V108.811Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.997 110.333H132.092V111.241H132.997V110.333Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.997 111.856H132.092V112.764H132.997V111.856Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.997 116.422H132.092V117.33H132.997V116.422Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.997 117.945H132.092V118.853H132.997V117.945Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.997 120.989H132.092V121.897H132.997V120.989Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.997 122.511H132.092V123.42H132.997V122.511Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.997 124.034H132.092V124.942H132.997V124.034Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.997 125.556H132.092V126.464H132.997V125.556Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.56 93.5883H130.655V94.4964H131.56V93.5883Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.56 95.1106H130.655V96.0187H131.56V95.1106Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.56 96.6329H130.655V97.541H131.56V96.6329Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.56 98.1552H130.655V99.0633H131.56V98.1552Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.56 99.6774H130.655V100.585H131.56V99.6774Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.56 101.2H130.655V102.108H131.56V101.2Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.56 102.722H130.655V103.63H131.56V102.722Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.56 104.244H130.655V105.152H131.56V104.244Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.56 105.766H130.655V106.675H131.56V105.766Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.56 107.289H130.655V108.197H131.56V107.289Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.56 108.811H130.655V109.719H131.56V108.811Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.56 110.333H130.655V111.241H131.56V110.333Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.56 111.856H130.655V112.764H131.56V111.856Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.56 113.378H130.655V114.286H131.56V113.378Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.56 116.422H130.655V117.33H131.56V116.422Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.56 119.467H130.655V120.375H131.56V119.467Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.56 120.989H130.655V121.897H131.56V120.989Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.56 122.511H130.655V123.42H131.56V122.511Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.56 124.034H130.655V124.942H131.56V124.034Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.56 125.556H130.655V126.464H131.56V125.556Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.288 102.268H139.383V103.176H140.288V102.268Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.288 103.79H139.383V104.698H140.288V103.79Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.288 105.313H139.383V106.221H140.288V105.313Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.288 106.835H139.383V107.743H140.288V106.835Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.288 108.357H139.383V109.265H140.288V108.357Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.288 109.879H139.383V110.788H140.288V109.879Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.288 114.446H139.383V115.354H140.288V114.446Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.288 115.968H139.383V116.877H140.288V115.968Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.288 117.49H139.383V118.398H140.288V117.49Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.288 119.013H139.383V119.921H140.288V119.013Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.288 120.535H139.383V121.443H140.288V120.535Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.288 122.057H139.383V122.965H140.288V122.057Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.288 123.579H139.383V124.488H140.288V123.579Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.851 102.268H137.946V103.176H138.851V102.268Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.851 103.79H137.946V104.698H138.851V103.79Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.851 105.313H137.946V106.221H138.851V105.313Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.851 106.835H137.946V107.743H138.851V106.835Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.851 108.357H137.946V109.265H138.851V108.357Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.851 109.879H137.946V110.788H138.851V109.879Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.851 114.446H137.946V115.354H138.851V114.446Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.851 115.968H137.946V116.877H138.851V115.968Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.851 117.49H137.946V118.398H138.851V117.49Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.851 119.013H137.946V119.921H138.851V119.013Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.851 120.535H137.946V121.443H138.851V120.535Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.851 122.057H137.946V122.965H138.851V122.057Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.851 125.102H137.946V126.01H138.851V125.102Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1117 95.5648H90.2068V96.4729H91.1117V95.5648Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1117 97.0867H90.2068V97.9948H91.1117V97.0867Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1117 98.6094H90.2068V99.5175H91.1117V98.6094Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1117 100.131H90.2068V101.039H91.1117V100.131Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1117 101.654H90.2068V102.562H91.1117V101.654Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1117 103.176H90.2068V104.084H91.1117V103.176Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1117 104.698H90.2068V105.606H91.1117V104.698Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1117 106.22H90.2068V107.128H91.1117V106.22Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1117 107.743H90.2068V108.651H91.1117V107.743Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1117 109.265H90.2068V110.173H91.1117V109.265Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1117 110.787H90.2068V111.695H91.1117V110.787Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1117 113.832H90.2068V114.74H91.1117V113.832Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1117 115.354H90.2068V116.262H91.1117V115.354Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1117 116.876H90.2068V117.784H91.1117V116.876Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1117 118.398H90.2068V119.307H91.1117V118.398Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1117 119.921H90.2068V120.829H91.1117V119.921Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1117 121.443H90.2068V122.351H91.1117V121.443Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1117 122.965H90.2068V123.873H91.1117V122.965Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1117 124.487H90.2068V125.396H91.1117V124.487Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6745 95.5648H88.7696V96.4729H89.6745V95.5648Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6745 97.0867H88.7696V97.9948H89.6745V97.0867Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6745 98.6094H88.7696V99.5175H89.6745V98.6094Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6745 100.131H88.7696V101.039H89.6745V100.131Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6745 101.654H88.7696V102.562H89.6745V101.654Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6745 103.176H88.7696V104.084H89.6745V103.176Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6745 104.698H88.7696V105.606H89.6745V104.698Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6745 106.22H88.7696V107.128H89.6745V106.22Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6745 107.743H88.7696V108.651H89.6745V107.743Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6745 109.265H88.7696V110.173H89.6745V109.265Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6745 110.787H88.7696V111.695H89.6745V110.787Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6745 112.309H88.7696V113.217H89.6745V112.309Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6745 113.832H88.7696V114.74H89.6745V113.832Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6745 115.354H88.7696V116.262H89.6745V115.354Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6745 116.876H88.7696V117.784H89.6745V116.876Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6745 118.398H88.7696V119.307H89.6745V118.398Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6745 119.921H88.7696V120.829H89.6745V119.921Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6745 121.443H88.7696V122.351H89.6745V121.443Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6745 122.965H88.7696V123.873H89.6745V122.965Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6745 124.487H88.7696V125.396H89.6745V124.487Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1899 101.494H97.285V102.402H98.1899V101.494Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1899 103.016H97.285V103.924H98.1899V103.016Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1899 104.538H97.285V105.446H98.1899V104.538Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1899 106.06H97.285V106.968H98.1899V106.06Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1899 107.583H97.285V108.491H98.1899V107.583Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1899 109.105H97.285V110.013H98.1899V109.105Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1899 110.627H97.285V111.535H98.1899V110.627Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1899 112.149H97.285V113.057H98.1899V112.149Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1899 113.671H97.285V114.58H98.1899V113.671Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1899 115.194H97.285V116.102H98.1899V115.194Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7533 101.494H95.8484V102.402H96.7533V101.494Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7533 103.016H95.8484V103.924H96.7533V103.016Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7533 104.538H95.8484V105.446H96.7533V104.538Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7533 106.06H95.8484V106.968H96.7533V106.06Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7533 107.583H95.8484V108.491H96.7533V107.583Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7533 109.105H95.8484V110.013H96.7533V109.105Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7533 110.627H95.8484V111.535H96.7533V110.627Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7533 112.149H95.8484V113.057H96.7533V112.149Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7533 113.671H95.8484V114.58H96.7533V113.671Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.303 43.7236H103.785V128.625H105.303V43.7236Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.87 43.7236H132.351V128.625H133.87V43.7236Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.436 43.7236H160.917V128.625H162.436V43.7236Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4171 140.124H52.8622V121.972C52.8622 121.086 53.5779 120.367 54.4614 120.367H63.8183C64.7014 120.367 65.4175 121.086 65.4175 121.972L65.4171 140.124Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4175 123.038H52.8625V124.453H65.4175V123.038Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1291 137.731H60.0014C59.5256 137.731 59.1398 138.118 59.1398 138.596V140.124H63.9908V138.596C63.9908 138.118 63.605 137.731 63.1291 137.731Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0071 140.124H60.5277C60.2195 140.124 59.9698 139.873 59.9698 139.564C59.9698 139.255 60.2195 139.004 60.5277 139.004H64.0071C64.3152 139.004 64.5649 139.255 64.5649 139.564C64.5649 139.873 64.3152 140.124 64.0071 140.124Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.751 39.7279C124.346 38.639 127.191 34.0178 126.106 29.4063C125.021 24.7947 120.416 21.9391 115.821 23.028C111.226 24.1169 108.381 28.738 109.466 33.3496C110.551 37.9612 115.156 40.8168 119.751 39.7279Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.957 38.5842C122.92 37.9388 125.611 34.1915 124.968 30.2145C124.324 26.2375 120.591 23.5367 116.628 24.1821C112.665 24.8276 109.974 28.5748 110.617 32.5519C111.26 36.5289 114.994 39.2297 118.957 38.5842Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.133 26.3806V31.4803L121.501 29.5679",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.133 26.3806V31.4803L121.501 29.5679",
    stroke: "#E0E0E0",
    strokeWidth: 2.29098,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9891 115.12C35.3358 114.041 34.26 114.98 34.26 114.98C34.4135 112.911 32.517 111.496 32.517 111.496C32.517 111.496 34.7209 111.496 35.0283 109.385C35.3358 107.275 34.26 108.256 33.2505 108.242C32.2411 108.227 31.186 111.187 32.517 112.852C33.848 114.516 33.4916 117.357 30.4172 120.09C29.6674 120.756 29.1574 121.644 28.8129 122.604C29.0449 120.093 29.1759 116.556 28.4398 114.195C27.1894 110.184 29.5719 109.105 30.2637 107.099C30.9555 105.094 28.4398 103.397 28.4398 103.397C28.4398 103.397 30.8016 102.318 29.6489 101.083C28.4961 99.8493 26.1136 100.017 26.1136 101.63C26.1136 103.243 27.7273 103.86 27.7273 103.86C27.7273 103.86 29.5715 105.788 29.5715 106.791C29.5715 107.794 27.7273 109.953 27.7273 109.953C27.7273 109.953 28.5727 108.105 26.882 108.026C25.1913 107.948 24.6534 110.184 25.3448 111.187C26.0363 112.19 27.189 111.341 27.189 111.341C27.189 111.341 27.3233 113.501 27.7172 114.812C27.8903 115.389 27.809 117.651 27.6634 120.005C27.323 119.155 26.8413 118.376 26.1666 117.776C23.0926 115.043 22.7358 112.202 24.0668 110.538C25.3978 108.874 24.3427 105.914 23.3333 105.929C22.3239 105.943 21.248 104.961 21.5555 107.072C21.8629 109.182 24.0668 109.182 24.0668 109.182C24.0668 109.182 22.1703 110.597 22.3239 112.666C22.3239 112.666 21.248 111.727 20.5947 112.807C19.4285 114.735 22.1315 115.931 22.5859 114.982C22.5859 114.982 28.3182 119.055 26.935 124.916L27.2562 125.392C27.2148 125.865 27.189 126.15 27.189 126.15L27.6373 125.956L28.1473 126.712C28.1208 128.177 28.2779 129.26 28.2779 129.26L29.6485 127.23C28.2652 121.368 33.9972 117.296 33.9972 117.296C34.4523 118.244 37.1553 117.048 35.9891 115.12Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.9891 115.12C35.3358 114.041 34.26 114.98 34.26 114.98C34.4135 112.911 32.517 111.496 32.517 111.496C32.517 111.496 34.7209 111.496 35.0283 109.385C35.3358 107.275 34.26 108.256 33.2505 108.242C32.2411 108.227 31.186 111.187 32.517 112.852C33.848 114.516 33.4916 117.357 30.4172 120.09C29.6674 120.756 29.1574 121.644 28.8129 122.604C29.0449 120.093 29.1759 116.556 28.4398 114.195C27.1894 110.184 29.5719 109.105 30.2637 107.099C30.9555 105.094 28.4398 103.397 28.4398 103.397C28.4398 103.397 30.8016 102.318 29.6489 101.083C28.4961 99.8493 26.1136 100.017 26.1136 101.63C26.1136 103.243 27.7273 103.86 27.7273 103.86C27.7273 103.86 29.5715 105.788 29.5715 106.791C29.5715 107.794 27.7273 109.953 27.7273 109.953C27.7273 109.953 28.5727 108.105 26.882 108.026C25.1913 107.948 24.6534 110.184 25.3448 111.187C26.0363 112.19 27.189 111.341 27.189 111.341C27.189 111.341 27.3233 113.501 27.7172 114.812C27.8903 115.389 27.809 117.651 27.6634 120.005C27.323 119.155 26.8413 118.376 26.1666 117.776C23.0926 115.043 22.7358 112.202 24.0668 110.538C25.3978 108.874 24.3427 105.914 23.3333 105.929C22.3239 105.943 21.248 104.961 21.5555 107.072C21.8629 109.182 24.0668 109.182 24.0668 109.182C24.0668 109.182 22.1703 110.597 22.3239 112.666C22.3239 112.666 21.248 111.727 20.5947 112.807C19.4285 114.735 22.1315 115.931 22.5859 114.982C22.5859 114.982 28.3182 119.055 26.935 124.916L27.2562 125.392C27.2148 125.865 27.189 126.15 27.189 126.15L27.6373 125.956L28.1473 126.712C28.1208 128.177 28.2779 129.26 28.2779 129.26L29.6485 127.23C28.2652 121.368 33.9972 117.296 33.9972 117.296C34.4523 118.244 37.1553 117.048 35.9891 115.12Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8679 140.124H21.7376L20.3214 125.697H36.2845L34.8679 140.124Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9855 124.105H19.6202V127.288H36.9855V124.105Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5479 156.618C130.415 156.618 161.923 154.771 161.923 152.493C161.923 150.215 130.415 148.368 91.5479 148.368C52.6809 148.368 21.1731 150.215 21.1731 152.493C21.1731 154.771 52.6809 156.618 91.5479 156.618Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.785 141.011C149.84 140.638 151.11 131.842 148.565 128.805C148.002 128.133 147.291 127.781 146.453 127.76C141.315 127.64 140.613 131.78 140.607 131.823L141.212 131.916C141.236 131.768 141.845 128.264 146.438 128.375C147.102 128.391 147.645 128.662 148.096 129.2C150.465 132.027 149.192 140.831 149.178 140.92L149.785 141.011Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.095 140.61L150.708 140.591C150.706 140.51 150.504 132.486 154.444 130.828C158.305 129.205 160.042 132.542 160.114 132.685L160.661 132.409C160.641 132.369 158.603 128.411 154.207 130.261C149.879 132.082 150.085 140.263 150.095 140.61Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.077 141.24C150.078 141.113 150.114 128.422 152.58 124.71C154.947 121.146 158.766 122.824 158.927 122.898L159.18 122.338C159.136 122.318 154.729 120.365 152.07 124.369C149.502 128.235 149.465 140.71 149.464 141.24L150.077 141.24Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.717 128.065C145.717 128.065 147.96 128.895 147.293 130.854C146.627 132.813 139.534 136.038 139.534 136.038C139.534 136.038 136.564 133.305 139.292 128.862C142.02 124.418 145.657 126.663 145.717 128.065Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.691 124.042C152.691 124.042 151.099 123.87 151.227 122.897C151.355 121.924 157.417 119.418 160.993 123.47C160.993 123.47 158.703 127.418 155.393 127.469C152.082 127.52 152.691 124.042 152.691 124.042Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.326 130.545C154.326 130.545 153.227 129.654 154.413 129.219C155.599 128.785 161.418 128.908 161.479 134.693C161.479 134.693 154.701 135.824 153.862 133.62C153.023 131.417 154.326 130.545 154.326 130.545Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M145.717 128.065C145.717 128.065 147.96 128.895 147.293 130.854C146.627 132.813 139.534 136.038 139.534 136.038C139.534 136.038 136.564 133.305 139.292 128.862C142.02 124.418 145.657 126.663 145.717 128.065Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M152.691 124.042C152.691 124.042 151.099 123.87 151.227 122.897C151.355 121.924 157.417 119.418 160.993 123.47C160.993 123.47 158.703 127.418 155.393 127.469C152.082 127.52 152.691 124.042 152.691 124.042Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M154.326 130.545C154.326 130.545 153.227 129.654 154.413 129.219C155.599 128.785 161.418 128.908 161.479 134.693C161.479 134.693 154.701 135.824 153.862 133.62C153.023 131.417 154.326 130.545 154.326 130.545Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.512 152.797H155.03L156.165 141.24H143.378L144.512 152.797Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M144.512 152.797H155.03L156.165 141.24H143.378L144.512 152.797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.816 142.515H156.726V139.965H142.816V142.515Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M142.816 142.515H156.726V139.965H142.816V142.515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.608 144.513L122.15 143.481V128.731H118.005V143.477L107.505 144.513C106.462 144.615 105.668 145.495 105.668 146.546V148.123H119.672H120.44H134.444V146.546C134.445 145.495 133.65 144.615 132.608 144.513Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M132.608 144.513L122.15 143.481V128.731H118.005V143.477L107.505 144.513C106.462 144.615 105.668 145.495 105.668 146.546V148.123H119.672H120.44H134.444V146.546C134.445 145.495 133.65 144.615 132.608 144.513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.775 152.797C108.271 152.797 109.484 151.579 109.484 150.077C109.484 148.575 108.271 147.358 106.775 147.358C105.278 147.358 104.065 148.575 104.065 150.077C104.065 151.579 105.278 152.797 106.775 152.797Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.338 152.797C134.834 152.797 136.048 151.579 136.048 150.077C136.048 148.575 134.834 147.358 133.338 147.358C131.841 147.358 130.628 148.575 130.628 150.077C130.628 151.579 131.841 152.797 133.338 152.797Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.363 131.901H118.791C117.963 131.901 117.291 131.228 117.291 130.396V118.764H122.863V130.396C122.863 131.228 122.192 131.901 121.363 131.901Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M121.363 131.901H118.791C117.963 131.901 117.291 131.228 117.291 130.396V118.764H122.863V130.396C122.863 131.228 122.192 131.901 121.363 131.901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.986 95.7084C129.986 95.7084 130.776 115.378 125.319 118.764H131.549C131.549 118.764 136.376 112.063 135.012 95.7084H129.986Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M129.986 95.7084C129.986 95.7084 130.776 115.378 125.319 118.764H131.549C131.549 118.764 136.376 112.063 135.012 95.7084H129.986Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.566 116.013H131.856C132.859 116.013 133.671 116.829 133.671 117.835V120.271H105.751V117.835C105.751 116.829 106.564 116.013 107.566 116.013Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.318 118.142H134.105C134.508 118.142 134.835 118.47 134.835 118.875V119.539C134.835 119.943 134.508 120.271 134.105 120.271H105.318C104.914 120.271 104.588 119.943 104.588 119.539V118.875C104.588 118.47 104.914 118.142 105.318 118.142Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M105.318 118.142H134.105C134.508 118.142 134.835 118.47 134.835 118.875V119.539C134.835 119.943 134.508 120.271 134.105 120.271H105.318C104.914 120.271 104.588 119.943 104.588 119.539V118.875C104.588 118.47 104.914 118.142 105.318 118.142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.539 99.7048H126.559C123.636 99.7048 121.266 97.3265 121.266 94.3923V90.4757C121.266 87.5416 123.636 85.1633 126.559 85.1633H136.539C139.463 85.1633 141.833 87.5416 141.833 90.4757V94.3923C141.833 97.3265 139.462 99.7048 136.539 99.7048Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.285 69.0911L94.2938 63.8202C94.2938 63.8202 95.1478 63.0268 94.562 62.2222C93.9762 61.4175 90.3008 59.1529 89.6308 59.551C88.9608 59.9488 87.4733 61.4499 88.2777 62.2826C89.0816 63.1153 92.6423 64.5054 92.6423 64.5054L94.4038 71.421L96.285 69.0911Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.198 79.1127C110.198 79.1127 101.135 77.243 100.152 76.7967C99.1696 76.3505 95.5207 65.6269 95.5207 65.6269L92.7244 66.9383C92.7244 66.9383 94.9755 77.699 97.2771 80.258C99.579 82.817 109.397 84.9811 109.397 84.9811L110.198 79.1127Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M109.396 84.9797C109.396 84.9797 109.339 84.9676 109.229 84.941C108.734 84.8292 107.186 84.4628 105.344 83.9226C102.355 83.0516 98.5913 81.7198 97.2756 80.2595C94.9773 77.6991 92.7233 66.9376 92.7233 66.9376L95.5188 65.6277C95.5188 65.6277 99.1674 76.3513 100.154 76.7972C101.136 77.2419 110.199 79.1121 110.199 79.1121L109.396 84.9797Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5648 65.4164L96.1427 66.5343L92.5493 67.7761L92.688 66.4097L95.5648 65.4164Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M109.465 84.8329C108.962 84.76 107.391 84.5149 105.513 84.1196C106.583 82.2644 109.719 81.3104 109.719 81.3104L109.465 84.8329Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.974 71.6898C122.974 71.6898 123.508 76.7276 121.647 77.9646C119.787 79.2017 110.64 77.7526 109.602 75.7262C108.564 73.6998 112.469 68.1961 112.469 68.1961L122.974 71.6898Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9558 137.98L88.3426 138.557L89.5506 135.25L90.6475 132.242L87.9289 131.078L86.8835 134.729L85.9558 137.98Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M86.8834 134.729L89.5505 135.25L90.6474 132.242L87.9288 131.078L86.8834 134.729Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1234 132.983L90.4336 134.218C90.4336 134.218 99.2645 112.06 101.079 111.983C102.894 111.907 121.373 120.43 126.004 115.702C130.636 110.978 123.939 99.5871 123.939 99.5871C123.939 99.5871 112.799 97.9916 111.961 100.516C111.798 101.004 111.62 101.962 111.489 102.782C111.362 103.554 111.275 104.202 111.275 104.202C111.275 104.202 111.271 104.202 111.268 104.199C110.923 104.111 99.74 101.215 95.3336 104.202C90.8583 107.24 87.1234 132.983 87.1234 132.983Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M87.1234 132.983L90.4336 134.218C90.4336 134.218 99.2645 112.06 101.079 111.983C102.894 111.907 121.373 120.43 126.004 115.702C130.636 110.978 123.939 99.5871 123.939 99.5871C123.939 99.5871 112.799 97.9916 111.961 100.516C111.798 101.004 111.62 101.962 111.489 102.782C111.362 103.554 111.275 104.202 111.275 104.202C111.275 104.202 111.271 104.202 111.268 104.199C110.923 104.111 99.74 101.215 95.3336 104.202C90.8583 107.24 87.1234 132.983 87.1234 132.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.163 147.432L108.541 146.82L108.084 143.397L107.659 140.256L104.718 140.521L105.482 144.18L106.163 147.432Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M105.501 144.254L108.101 143.462L107.668 140.289L104.722 140.537L105.501 144.254Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8006 132.989L86.9794 131.344L86.7732 133.326L90.4305 134.624L91.8006 132.989Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.004 116.839C118.004 116.839 117.25 116.857 105.566 116.31C105.566 116.31 107.312 130.97 108.264 141.945L104.771 142.543C104.771 142.543 96.4224 119.043 96.5131 115.309C96.6039 111.575 100.869 110.483 100.869 110.483C100.869 110.483 109.193 115.309 118.004 116.839Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M118.004 116.839C118.004 116.839 117.25 116.857 105.566 116.31C105.566 116.31 107.312 130.97 108.264 141.945L104.771 142.543C104.771 142.543 96.4224 119.043 96.5131 115.309C96.6039 111.575 100.869 110.483 100.869 110.483C100.869 110.483 109.193 115.309 118.004 116.839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M118.004 116.839C118.004 116.839 117.25 116.857 105.566 116.31C105.566 116.31 107.312 130.97 108.264 141.945L104.771 142.543C104.771 142.543 96.4224 119.043 96.5131 115.309C96.6039 111.575 100.869 110.483 100.869 110.483C100.869 110.483 109.193 115.309 118.004 116.839Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.776 140.881L103.974 141.43L104.9 143.319L108.787 142.819L108.776 140.881Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M111.275 104.202L117.79 105.565C117.79 105.565 114.19 103.568 111.489 102.782C111.362 103.554 111.275 104.202 111.275 104.202Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.67 97.8492L123.938 99.5882L111.96 100.515L111.644 98.4586L123.67 97.8492Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M123.67 97.8492L123.938 99.5882L111.96 100.515L111.644 98.4586L123.67 97.8492Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.885 100.76L120.477 100.699L120.167 97.6738L119.575 97.7349L119.885 100.76Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.581 100.455L117.205 100.286L117.077 98.289L114.453 98.4582L114.581 100.455Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.548 101.086L113.14 101.025L112.83 98.0004L112.238 98.0615L112.548 101.086Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M119.885 100.76L120.477 100.699L120.167 97.6738L119.575 97.7349L119.885 100.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M112.548 101.086L113.14 101.025L112.83 98.0004L112.238 98.0615L112.548 101.086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.981 78.9467C109.981 78.9467 113.039 79.9095 116.882 79.7113C120.725 79.5131 125.32 81.3866 125.32 81.3866L123.67 97.8492L111.643 98.4586C111.643 98.4586 107.603 84.7112 109.981 78.9467Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.913 69.6502C111.913 69.6502 112.589 61.6553 119.248 64.5604C127.606 68.2067 120.959 77.9442 116.876 75.9451C112.793 73.946 111.913 69.6502 111.913 69.6502Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M113.779 80.1579L113.971 84.6752L115.464 82.55C115.464 82.55 114.932 87.5463 115.243 90.2666C115.243 90.2666 115.529 85.3884 116.205 82.55L117.79 84.6752L120.068 80.1856C120.068 80.1856 116.383 78.8571 113.779 80.1579Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.842 80.9982L119.285 80.022C117.163 78.5565 118.233 75.28 118.233 75.28L114.822 76.4835C115.004 77.0514 115.119 77.534 115.188 77.946C115.545 80.0814 114.584 80.2518 114.584 80.2518L115.842 80.9982Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M114.823 76.4835C115.005 77.0514 115.12 77.534 115.188 77.946C116.821 77.2893 118.233 75.28 118.233 75.28L114.823 76.4835Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.049 66.239C114.028 65.568 112.697 66.9751 111.787 70.0503C110.649 73.8933 110.9 76.8588 114.861 76.8639C120.241 76.8704 122.065 67.3532 117.049 66.239Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.777 70.3148C113.777 70.3148 113.184 71.0138 112.621 71.377C112.621 71.377 112.788 71.8469 113.342 71.8968L113.777 70.3148Z",
    fill: "#DE5753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.681 70.4776C115.62 70.7253 115.705 70.9591 115.869 70.9995C116.033 71.04 116.216 70.8724 116.277 70.6247C116.338 70.377 116.253 70.1432 116.089 70.1024C115.924 70.0616 115.742 70.2295 115.681 70.4776Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.154 70.1312L115.669 69.7873C115.669 69.7873 115.826 70.3067 116.154 70.1312Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.625 69.6682C112.564 69.9159 112.648 70.1498 112.813 70.1906C112.977 70.2314 113.16 70.0634 113.221 69.8157C113.281 69.568 113.197 69.3342 113.033 69.2937C112.868 69.2526 112.685 69.4205 112.625 69.6682Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.098 69.3221L112.613 68.9783C112.613 68.9783 112.769 69.4977 113.098 69.3221Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.173 68.3907C116.173 68.3907 117.046 68.4686 117.382 69.14",
    stroke: "#263238",
    strokeWidth: 0.830136,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.005 67.7747C114.005 67.7747 113.515 67.4578 112.747 67.7565",
    stroke: "#263238",
    strokeWidth: 0.830136,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.223 72.0822C119.223 72.0822 118.36 69.2777 118.998 67.4021C118.998 67.4021 113.553 63.6181 111.913 69.6507C111.913 69.6507 112.522 64.1058 117.742 65.1385C122.953 66.1698 121.258 73.7909 118.075 75.4669C118.075 75.4669 119.754 73.8339 119.223 72.0822Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.589 72.6125C118.717 72.1288 119.401 71.4141 120.284 71.7142C121.197 72.0246 121.218 74.0525 118.787 73.9989C118.438 73.9913 118.322 73.6215 118.589 72.6125Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.801 73.0485C112.908 73.4496 112.958 74.1752 112.958 74.1752C113.024 74.1825 113.09 74.1898 113.157 74.1938C114.059 74.2706 114.502 74.0073 114.721 73.6922C114.839 73.5192 114.889 73.3283 114.909 73.1705C114.934 72.9888 114.91 72.8533 114.91 72.8533C114.407 73.0992 113.561 73.0926 113.109 73.0696C112.92 73.0624 112.801 73.0485 112.801 73.0485Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.109 73.0696L113.164 73.4008C114.013 73.4711 114.621 73.4062 114.909 73.1705C114.934 72.9888 114.91 72.8533 114.91 72.8533C114.407 73.0992 113.561 73.0922 113.109 73.0696Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.157 74.1934C114.059 74.2702 114.502 74.0069 114.721 73.6918C114.413 73.6776 114.039 73.6947 113.702 73.8054C113.445 73.8896 113.275 74.0382 113.157 74.1934Z",
    fill: "#DE5753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.06 66.4816C117.06 66.4816 117.177 71.7405 120.321 72.3717C123.465 73.003 120.028 65.6139 120.028 65.6139C120.028 65.6139 115.347 62.5453 112.227 64.7079C109.106 66.8706 111.913 69.6507 111.913 69.6507C111.913 69.6507 112.572 65.7443 117.06 66.4816Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.169 66.134C117.169 66.134 116.048 69.4583 118.261 71.2035",
    stroke: "#263238",
    strokeWidth: 0.572745,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.239 73.4536C120.839 74.523 119.812 75.1248 118.945 74.7984C118.078 74.4717 117.7 73.3403 118.1 72.2712C118.5 71.2017 119.527 70.5999 120.394 70.9263C121.26 71.2527 121.639 72.3841 121.239 73.4536Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M121.239 73.4536C120.839 74.523 119.812 75.1248 118.945 74.7984C118.078 74.4717 117.7 73.3403 118.1 72.2712C118.5 71.2017 119.527 70.5999 120.394 70.9263C121.26 71.2527 121.639 72.3841 121.239 73.4536Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.238 71.7C120.238 71.7 121.54 65.8462 118.618 64.312C118.618 64.312 119.227 64.3943 119.605 64.5046C119.982 64.615 122.316 66.9889 121.136 72.25L120.238 71.7Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M120.238 71.7C120.238 71.7 121.54 65.8462 118.618 64.312C118.618 64.312 119.227 64.3943 119.605 64.5046C119.982 64.615 122.316 66.9889 121.136 72.25L120.238 71.7Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.759 75.0502C114.687 75.0407 114.614 75.0298 114.541 75.0174L114.6 74.6582C117.23 75.088 119.187 73.6911 119.207 73.6765L119.421 73.9705C119.34 74.0306 117.436 75.4035 114.759 75.0502Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.759 75.0502C114.687 75.0407 114.614 75.0298 114.541 75.0174L114.6 74.6582C117.23 75.088 119.187 73.6911 119.207 73.6765L119.421 73.9705C119.34 74.0306 117.436 75.4035 114.759 75.0502Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M121.116 73.3071C120.852 74.0142 120.173 74.412 119.6 74.1963C119.027 73.9803 118.777 73.2325 119.041 72.5254C119.306 71.8184 119.984 71.4206 120.557 71.6363C121.131 71.8523 121.381 72.6001 121.116 73.3071Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.435 75.1697L114.143 75.131C113.927 75.1026 113.775 74.9034 113.803 74.6863C113.831 74.4692 114.03 74.3165 114.246 74.345L114.537 74.3836C114.754 74.412 114.906 74.6112 114.877 74.8283C114.849 75.0454 114.651 75.1981 114.435 75.1697Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M114.435 75.1697L114.143 75.131C113.927 75.1026 113.775 74.9034 113.803 74.6863C113.831 74.4692 114.03 74.3165 114.246 74.345L114.537 74.3836C114.754 74.412 114.906 74.6112 114.877 74.8283C114.849 75.0454 114.651 75.1981 114.435 75.1697Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.362 78.7693L116.205 80.8951L117.068 83.5L120.068 80.1855L118.362 78.7693Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.243 79.2137L115.592 80.85L114.475 83.1638L113.779 80.1579L115.243 79.2137Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.9 80.6147L119.153 76.014C119.153 76.014 118.546 74.868 118.677 74.628C118.808 74.3883 119.46 71.2993 119.925 70.9627C120.389 70.6265 122.3 71.2006 122.494 71.5139C122.687 71.8271 120.662 76.0136 120.662 76.0136L119.925 80.9979L117.9 80.6147Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.32 81.3866C128.766 84.9269 121.859 92.9473 117.9 92.6056C113.942 92.2639 117.999 77.7206 117.999 77.7206L120.534 78.1391C120.534 78.1391 119.644 84.4329 119.925 84.9269C120.206 85.4204 124.162 80.1965 125.32 81.3866Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M125.32 81.3866C128.766 84.9269 121.859 92.9473 117.9 92.6056C113.942 92.2639 117.999 77.7206 117.999 77.7206L120.534 78.1391C120.534 78.1391 119.644 84.4329 119.925 84.9269C120.206 85.4204 124.162 80.1965 125.32 81.3866Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.791 77.2554L117.415 78.4564L120.947 78.7693V77.7206L117.791 77.2554Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M112.439 90.0528H111.008C110.85 90.0528 110.721 89.9238 110.721 89.7646V87.0549C110.721 86.8957 110.85 86.7667 111.008 86.7667H112.439C112.598 86.7667 112.726 86.8957 112.726 87.0549V89.7646C112.726 89.9238 112.598 90.0528 112.439 90.0528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M112.468 86.9827H110.841V89.2164H112.468V86.9827Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.87 85.9738H111.511V87.2902H111.87V85.9738Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0038 142.632C82.3667 142.465 82.7569 142.365 83.1558 142.339C83.1558 142.339 84.5343 141.524 85.9005 138.361L87.437 138.352C87.9687 138.358 88.4406 138.697 88.6173 139.2C88.6427 139.269 88.6573 139.341 88.6609 139.414C88.6453 139.786 88.6061 140.158 88.5429 140.525C88.4046 141.678 87.6446 144.153 87.6446 144.153L87.3843 144.086L87.8576 141.785C88.0152 141.004 87.1967 141.759 86.817 142.547C86.4374 143.335 85.8552 144.129 84.1583 143.739C82.1809 143.275 81.3838 142.989 82.0038 142.632Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1787 137.532C86.1787 137.532 84.2604 141.561 83.1555 142.338C83.1555 142.338 84.6364 143.225 86.1787 141.252C88.1728 138.701 88.6606 139.414 88.6606 139.414C88.6606 139.414 88.5761 138.541 88.4203 138.114C88.1213 137.29 86.1787 137.532 86.1787 137.532Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.136 152.232C103.449 151.983 103.804 151.793 104.186 151.672C104.186 151.672 105.332 150.553 105.912 147.155L107.402 146.78C107.921 146.66 108.459 146.877 108.749 147.324C108.79 147.384 108.821 147.451 108.842 147.521C108.915 147.887 108.964 148.256 108.99 148.629C109.128 149.782 108.974 152.367 108.974 152.367L108.706 152.364L108.622 150.016C108.59 149.219 107.973 150.148 107.791 151.004C107.608 151.86 107.23 152.769 105.49 152.795C103.46 152.814 102.618 152.726 103.136 152.232Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.986 146.283C105.986 146.283 105.075 150.654 104.185 151.672C104.185 151.672 105.834 152.18 106.866 149.897C108.2 146.944 108.842 147.52 108.842 147.52C108.842 147.52 108.554 146.692 108.302 146.314C107.816 145.586 105.986 146.283 105.986 146.283Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.735 67.2479H127.062C126.046 67.2479 125.223 66.4218 125.223 65.4029V59.9604C125.223 58.9416 126.046 58.1154 127.062 58.1154H139.735C140.75 58.1154 141.573 58.9416 141.573 59.9604V65.4029C141.573 66.4218 140.75 67.2479 139.735 67.2479Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.605 66.2068L125.787 71.4151L131.947 66.5562L129.605 66.2068Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.748 62.6815C129.748 62.9784 129.508 63.2188 129.212 63.2188C128.916 63.2188 128.677 62.978 128.677 62.6815C128.677 62.3846 128.916 62.1442 129.212 62.1442C129.508 62.1442 129.748 62.3846 129.748 62.6815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.538 62.6815C132.538 62.9784 132.298 63.2188 132.003 63.2188C131.707 63.2188 131.467 62.978 131.467 62.6815C131.467 62.3846 131.707 62.1442 132.003 62.1442C132.298 62.1442 132.538 62.3846 132.538 62.6815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.329 62.6815C135.329 62.9784 135.09 63.2188 134.794 63.2188C134.498 63.2188 134.258 62.978 134.258 62.6815C134.258 62.3846 134.498 62.1442 134.794 62.1442C135.09 62.1442 135.329 62.3846 135.329 62.6815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.12 62.6815C138.12 62.9784 137.88 63.2188 137.585 63.2188C137.289 63.2188 137.049 62.978 137.049 62.6815C137.049 62.3846 137.289 62.1442 137.585 62.1442C137.88 62.1442 138.12 62.3846 138.12 62.6815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8007 60.0668L79.7629 55.1817C79.5186 55.0494 79.4271 54.7438 79.5589 54.4983L82.4412 49.1272C82.5729 48.8821 82.8775 48.7903 83.1221 48.9221L92.1599 53.8073C92.4042 53.9395 92.4956 54.2451 92.3643 54.4907L89.482 59.8617C89.3498 60.1069 89.0449 60.1987 88.8007 60.0668Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M88.8007 60.0668L79.7629 55.1817C79.5186 55.0494 79.4271 54.7438 79.5589 54.4983L82.4412 49.1272C82.5729 48.8821 82.8775 48.7903 83.1221 48.9221L92.1599 53.8073C92.4042 53.9395 92.4956 54.2451 92.3643 54.4907L89.482 59.8617C89.3498 60.1069 89.0449 60.1987 88.8007 60.0668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M82.2027 49.5712L85.0302 54.8702C85.2505 55.2829 85.6963 55.5219 86.1605 55.4756L92.0456 54.8917L86.0549 55.7769C85.5177 55.8563 84.9925 55.5721 84.7627 55.0786L82.2027 49.5712Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3386 48.5841C75.4348 46.5573 76.9294 42.4739 78.7483 41.2252C80.5671 39.9761 79.3704 41.7057 79.3704 41.7057C79.3704 41.7057 81.0934 40.0246 82.003 40.0727C82.9125 40.1207 82.003 41.1775 82.003 41.1775C82.003 41.1775 83.8697 40.0228 84.7314 40.0716C85.593 40.1207 84.7314 41.1294 84.7314 41.1294C84.7314 41.1294 86.2631 40.0246 86.8852 40.5531C87.5073 41.0817 78.9399 46.7497 77.9828 49.0555C77.0253 51.3605 75.2413 50.6353 75.3386 48.5841Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M75.3386 48.5841C75.4348 46.5573 76.9294 42.4739 78.7483 41.2252C80.5671 39.9761 79.3704 41.7057 79.3704 41.7057C79.3704 41.7057 81.0934 40.0246 82.003 40.0727C82.9125 40.1207 82.003 41.1775 82.003 41.1775C82.003 41.1775 83.8697 40.0228 84.7314 40.0716C85.593 40.1207 84.7314 41.1294 84.7314 41.1294C84.7314 41.1294 86.2631 40.0246 86.8852 40.5531C87.5073 41.0817 78.9399 46.7497 77.9828 49.0555C77.0253 51.3605 75.2413 50.6353 75.3386 48.5841Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.697 48.285L83.8415 49.0205C83.9239 49.0733 83.881 49.2015 83.7834 49.1939L82.5812 49.0999L82.6847 50.0259C82.6959 50.1264 82.5715 50.1818 82.5047 50.106L81.8114 49.3181L82.697 48.285Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M82.697 48.285L83.8415 49.0205C83.9239 49.0733 83.881 49.2015 83.7834 49.1939L82.5812 49.0999L82.6847 50.0259C82.6959 50.1264 82.5715 50.1818 82.5047 50.106L81.8114 49.3181L82.697 48.285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.639 43.7237C66.639 43.7237 68.2186 42.6181 70.6116 43.3387C70.6116 43.3387 71.2998 46.5089 73.1814 47.5656C74.2148 48.1459 76.7464 48.096 78.7486 47.4454C81.1263 46.6728 82.2904 46.6728 82.7212 47.5656C83.1292 48.4111 82.6733 49.3909 80.8545 49.8233C79.0357 50.2557 77.5998 53.4259 74.2972 53.474C70.9946 53.5221 69.2563 50.1989 70.0853 47.2775C70.0853 47.2775 69.0799 45.0999 66.639 43.7237Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M66.639 43.7237C66.639 43.7237 68.2186 42.6181 70.6116 43.3387C70.6116 43.3387 71.2998 46.5089 73.1814 47.5656C74.2148 48.1459 76.7464 48.096 78.7486 47.4454C81.1263 46.6728 82.2904 46.6728 82.7212 47.5656C83.1292 48.4111 82.6733 49.3909 80.8545 49.8233C79.0357 50.2557 77.5998 53.4259 74.2972 53.474C70.9946 53.5221 69.2563 50.1989 70.0853 47.2775C70.0853 47.2775 69.0799 45.0999 66.639 43.7237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8117 48.1663C81.8117 48.2559 81.7395 48.3284 81.6502 48.3284C81.5609 48.3284 81.4887 48.2559 81.4887 48.1663C81.4887 48.0767 81.5609 48.0042 81.6502 48.0042C81.7395 48.0042 81.8117 48.0767 81.8117 48.1663Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5305 50.8342C71.58 51.3678 67.2487 51.2013 65.5036 49.8507C63.7585 48.5 65.7667 49.1083 65.7667 49.1083C65.7667 49.1083 63.6416 47.9823 63.4064 47.0994C63.1712 46.2164 64.4535 46.7584 64.4535 46.7584C64.4535 46.7584 62.7828 45.333 62.5632 44.4956C62.3436 43.6581 63.5657 44.1692 63.5657 44.1692C63.5657 44.1692 62.046 43.048 62.3545 42.291C62.663 41.5341 70.6798 47.963 73.1607 48.1648C75.6415 48.3674 75.5047 50.294 73.5305 50.8342Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M73.5305 50.8342C71.58 51.3678 67.2487 51.2013 65.5036 49.8507C63.7585 48.5 65.7667 49.1083 65.7667 49.1083C65.7667 49.1083 63.6416 47.9823 63.4064 47.0994C63.1712 46.2164 64.4535 46.7584 64.4535 46.7584C64.4535 46.7584 62.7828 45.333 62.5632 44.4956C62.3436 43.6581 63.5657 44.1692 63.5657 44.1692C63.5657 44.1692 62.046 43.048 62.3545 42.291C62.663 41.5341 70.6798 47.963 73.1607 48.1648C75.6415 48.3674 75.5047 50.294 73.5305 50.8342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7553 41.8368C60.4141 41.7148 60.0689 41.6011 59.7208 41.4951",
    stroke: "#8B4EE3",
    strokeWidth: 0.859117,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5987 40.952C56.3265 40.6846 55.0333 40.5112 53.7488 40.4216C50.2197 40.175 44.6873 39.8242 42.5255 43.3536C40.5557 46.5697 43.9447 52.057 45.1476 55.0429C46.6209 58.6998 48.3725 63.2218 46.6317 67.0932C43.0544 75.0484 27.7409 70.9176 22.5752 63.5908",
    stroke: "#8B4EE3",
    strokeWidth: 0.859117,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.91 6.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.988 62.6655C21.8062 62.3442 21.6443 62.0178 21.5038 61.6871",
    stroke: "#8B4EE3",
    strokeWidth: 0.859117,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0705 91.5893H52.2931V94.4251H66.0705V91.5893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M66.0705 91.5893H52.2931V94.4251H66.0705V91.5893Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M58.0958 91.5893H52.2931V94.4251H58.0958V91.5893Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M52.2932 91.9976H64.5574L52.2932 92.3459V91.9976Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M66.0706 92.4901L55.4394 92.7542H66.0706V92.4901Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M52.8547 93.2828L58.0959 93.0664L65.8017 93.2828L58.0959 93.4026L52.8547 93.2828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M52.2932 93.8831H61.3745L52.2932 94.0991V93.8831Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M66.0509 94.0991L59.9861 94.212H66.0705L66.0509 94.0991Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1532 88.7535H50.3758V91.5893H64.1532V88.7535Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M64.1532 88.7535H50.3758V91.5893H64.1532V88.7535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M56.1785 88.7535H50.3758V91.5893H56.1785V88.7535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M50.3757 89.1618H62.6399L50.3757 89.51V89.1618Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M64.1535 89.6543L53.5219 89.9184H64.1535V89.6543Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M50.9375 90.447L56.1784 90.2306L63.8845 90.447L56.1784 90.5668L50.9375 90.447Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M50.3757 91.0472H59.4571L50.3757 91.2633V91.0472Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M64.1336 91.2633L58.0692 91.3762H64.1535L64.1336 91.2633Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7263 85.9177H51.9489V88.7535H65.7263V85.9177Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M65.7263 85.9177H51.9489V88.7535H65.7263V85.9177Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M57.7516 85.9177H51.9489V88.7535H57.7516V85.9177Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M51.9489 86.326H64.2131L51.9489 86.6742V86.326Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M65.7267 86.8185L55.0951 87.0826H65.7267V86.8185Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M52.5107 87.6108L57.7516 87.3948L65.4576 87.6108L57.7516 87.731L52.5107 87.6108Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M51.9489 88.2114H61.0303L51.9489 88.4274V88.2114Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M65.7067 88.4274L59.6423 88.5404H65.7267L65.7067 88.4274Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9045 94.3657L75.2628 93.007H89.9817L96.7597 93.6864L97.0174 94.3657H74.9045Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M89.9817 93.007V94.3657H74.9045L75.2628 93.007H89.9817Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0246 86.503C87.0899 87.2206 86.5673 87.8035 85.8559 87.8035H63.3085C62.5935 87.8035 61.9619 87.2206 61.8966 86.503L60.5572 72.0162C60.5427 71.8668 60.5536 71.7248 60.5863 71.5936C60.7133 71.0837 61.1598 70.7158 61.726 70.7158H84.2733C84.9884 70.7158 85.6199 71.2986 85.6853 72.0162L87.0246 86.503Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M85.7763 87.8034H63.3088C62.5938 87.8034 61.9623 87.2206 61.8969 86.503L60.5576 72.0162C60.5431 71.8668 60.554 71.7248 60.5866 71.5936H83.0541C83.7655 71.5936 84.3971 72.1765 84.466 72.8941L85.8054 87.3809C85.8199 87.5302 85.8086 87.6723 85.7763 87.8034Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2857 78.9183H74.9502L73.7067 92.3207L81.0828 93.4321V94.3657H65.5479V93.4321L68.7304 92.3207L70.2857 78.9183Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M74.9503 78.9183L71.4945 94.1526L68.7305 94.0703L70.2858 78.9183H74.9503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9284 152.797H72.7048L68.7097 96.9742H71.6599L74.9284 152.797Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M74.9301 152.797H72.7052L68.9049 99.747L68.7089 97.0642H71.6598L71.8195 99.747L74.9301 152.797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M71.8195 99.6141H68.9049L68.7089 97.0642H71.6598L71.8195 99.6141Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2472 152.797H89.0236L88.6607 96.9742H91.6105L91.2472 152.797Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M91.6119 97.0642L91.5538 106.071L91.2489 152.797H89.0239L88.719 106.071L88.6609 97.0642H91.6119Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M91.6119 97.0642L91.5538 106.171H88.719L88.6609 97.0642H91.6119Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.855 152.797H112.631L108.636 96.9742H111.586L114.855 152.797Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M114.856 152.797H112.631L108.831 99.747L108.635 97.0642H111.586L111.746 99.747L114.856 152.797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.746 99.6141H108.831L108.635 97.0642H111.586L111.746 99.6141Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4917 152.797H47.2679L50.5367 96.9742H53.4865L49.4917 152.797Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M53.4859 97.0642L53.2899 99.747L49.4897 152.797H47.2684L50.3753 99.747L50.5351 97.0642H53.4859Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.5351 97.0642H53.486L53.29 99.6141H50.3754L50.5351 97.0642Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.14 98.3723H48.9833C48.5499 98.3723 48.1986 98.0197 48.1986 97.5847V95.5762H113.925V97.5844C113.925 98.0197 113.573 98.3723 113.14 98.3723Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M113.14 98.3723H48.9833C48.5499 98.3723 48.1986 98.0197 48.1986 97.5847V95.5762H113.925V97.5844C113.925 98.0197 113.573 98.3723 113.14 98.3723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M113.925 95.5762H48.1986V96.9742H113.925V95.5762Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.303 95.9408H46.8204C46.3871 95.9408 46.0357 95.5882 46.0357 95.1533C46.0357 94.7183 46.3871 94.3657 46.8204 94.3657H115.303C115.736 94.3657 116.088 94.7183 116.088 95.1533C116.087 95.5882 115.736 95.9408 115.303 95.9408Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M115.303 95.9408H46.8204C46.3871 95.9408 46.0357 95.5882 46.0357 95.1533C46.0357 94.7183 46.3871 94.3657 46.8204 94.3657H115.303C115.736 94.3657 116.088 94.7183 116.088 95.1533C116.087 95.5882 115.736 95.9408 115.303 95.9408Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0996 91.9393L99.9431 90.672C100.111 90.4192 100.394 90.2677 100.697 90.2677H101.765C101.854 90.2677 101.943 90.2808 102.028 90.3067L105.835 91.4647C106.051 91.5306 106.235 91.6752 106.351 91.8701L106.897 92.7917L99.0996 91.9393Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M106.897 92.7921L101.354 92.1874L99.1004 91.9397L99.9425 90.672C100.109 90.4207 100.393 90.2677 100.697 90.2677H101.765C101.855 90.2677 101.942 90.2823 102.03 90.3078L102.113 90.3333L105.833 91.4661C106.051 91.5317 106.236 91.6738 106.352 91.8705L106.897 92.7921Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M106.897 92.7921L101.355 92.1874L102.113 90.3333L105.834 91.4662C106.051 91.5317 106.236 91.6738 106.353 91.8705L106.897 92.7921Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.532 94.2452V94.3654H104.701H97.7645L98.2001 92.657C98.3707 92.0159 98.9514 91.5678 99.612 91.5678H104.831C105.006 91.5678 105.176 91.597 105.34 91.6589L105.993 91.9029L108.584 92.8719C109.155 93.0872 109.532 93.6336 109.532 94.2452Z",
    fill: "#8B4EE3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M109.532 94.2452V94.3654H104.701L104.958 92.5186C105.027 92.0304 105.532 91.7317 105.993 91.9029L108.584 92.8719C109.155 93.0872 109.532 93.6336 109.532 94.2452Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.453 93.1101L106.99 88.481C107.056 88.281 107.285 88.1881 107.471 88.2847C107.614 88.3582 107.686 88.5214 107.645 88.6766L106.351 93.6186C106.351 93.6186 105.489 93.9683 105.453 93.1101Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M99.0995 93.981H98.4175L98.5489 93.3086H99.2309L99.0995 93.981Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M100.117 93.9548H99.4346L99.566 93.2824H100.248L100.117 93.9548Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1241_4146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 181.482,
    height: 182.133,
    fill: "white",
    transform: "translate(0.806763 0.871826)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactus);
export default __webpack_public_path__ + "static/media/contactus.0fb414a35546e69318e9e0fc695e19a7.svg";
export { ForwardRef as ReactComponent };